import { render, staticRenderFns } from "./addAlert.vue?vue&type=template&id=3b12eb1d&scoped=true"
import script from "./addAlert.vue?vue&type=script&lang=js"
export * from "./addAlert.vue?vue&type=script&lang=js"
import style0 from "./addAlert.vue?vue&type=style&index=0&id=3b12eb1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b12eb1d",
  null
  
)

export default component.exports